import { useState, useEffect } from 'react'
import { customFetch } from '@/utils/fetch'

export const useVideoUrl = (recordingUrl: string | undefined) => {
  const [url, setUrl] = useState<string | null>(null)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!recordingUrl) return

    // If the recordingUrl is already a fully qualified URL, use it directly
    if (recordingUrl.startsWith('http')) {
      setUrl(recordingUrl)
      return
    }

    const fetchUrl = async () => {
      try {
        const response = await customFetch(`/getMeetUrlByStoredName/${recordingUrl}`, 'GET', null)
        if (response.error) throw response.error
        setUrl(response.url)
      } catch (err) {
        console.error('Error fetching video URL:', err)
        setError(err as Error)
      }
    }

    fetchUrl()
  }, [recordingUrl])

  return { url, error }
}
